import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import disbursmentImage from "@assets/images/disbursment_image.svg";
import { Group } from "@domain/group/group";
import { useDisbursementLists } from "@domain/wallet/hook";
import { useModalTools } from "@ui/modals/modalContext";
import { DisbursementList } from "@ui/components/wallet/disbursementList";
import { EmptyTable } from "@ui/components/wallet/EmptyTable";
import { SeeMoreDisbursement } from "@ui/components/group/shareroom/dashboard/seemore/seemoreDisbursement";

interface LastDisbursementOnMobileProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}
export const LastDisbursementOnMobile: React.FC<LastDisbursementOnMobileProps> = ({ shareroom }) => {
	const { result: disbursementList } = useDisbursementLists(shareroom.id);
	const { createModal } = useModalTools();
	return (
		<>
			<ContainerDescription>
				<StyledTitle>{I18n.t("shareroom.dashboard.transactions.cashout.title")}</StyledTitle>
				<StyledDescription>{I18n.t("shareroom.dashboard.transactions.cashout.description")}</StyledDescription>
			</ContainerDescription>
			{disbursementList?.length === 0 ? (
				<EmptyTable source={disbursmentImage} />
			) : (
				<ContainerDisbursement>
					<ShowMore onClick={() => createModal((close) => <SeeMoreDisbursement shareroom={shareroom} close={close} />)}>
						{I18n.t("see_more")}
					</ShowMore>
					<DisbursementList shareroom={shareroom} disbursementList={disbursementList} />
				</ContainerDisbursement>
			)}
		</>
	);
};

const ContainerDescription = styled.div`
	margin-bottom: 30px;
`;

const StyledTitle = styled.div`
	font-weight: 600;
	font-size: 16px;
	line-height: 26px;
`;

const StyledDescription = styled.div`
	font-weight: 400;
	font-size: 10px;
	line-height: 26px;
`;
const ContainerDisbursement = styled.div`
	display: flex;
	flex-direction: column;
`;
const ShowMore = styled.div`
	display: flex;
	justify-content: flex-end;
	font-size: 14px;
	line-height: 26px;
	${({ theme }) => theme.textStyles.text};
	color: ${({ theme }) => theme.colors.secondary};
	margin-bottom: 20px;
	cursor: pointer;
`;
